export const VERSION = "v4.0.0-rc.3";
